import {
  FOC_TOUR_LABEL_PLN_DOCS,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_PLN_DOCS_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
  focPlnTourPopoverHtml,
  requirement,
  type FocPlnTourStepDef,
} from './focPlnTourTypes';

export const FOC_PLN_DOCS_TOUR_PARAM = 'focPlnDocsTour';
export const FOC_PLN_DOCS_TOUR_HREF = HREF;
export { focPlnTourPopoverHtml };

export const FOC_PLN_DOCS_TOUR_STEPS: FocPlnTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'pln-docs-workspace',
    title: FOC_TOUR_LABEL_PLN_DOCS,
    description:
      'The Documentation Unit workspace collects, organizes, reviews, archives, exports, and retrieves incident records, IAP components, forms, activity logs, approvals, signatures, documentation status, and closeout records.',
  },
  requirement({
    id: 'pln004',
    requirementId: 'FOC-PLN-004',
    name: 'Documentation Unit Workspace',
    disposition: FOC_REQUIRED_DISPOSITION,
    tour: 'pln-docs-workspace',
    description:
      'PRATUS provides a Documentation Unit workspace for collecting, organizing, reviewing, archiving, exporting, and retrieving incident records, IAP components, submitted forms, activity logs, approvals, signatures, documentation status, and records required for incident closeout.',
    bullets: [
      'FOC-PLN-004a — ICS 214 Collection and Archive: daily or shift-based ICS 214 collection, submission, review, revision history, archive, and export without requiring the operational period to be limited to 24 hours.',
      'FOC-PLN-004b — Incident Records Collection Status: identifies required/expected records, owner, operational period, status, version, approval, receipt/submission, and gaps.',
      'FOC-PLN-004c — ICS 214 Compliance Tracking: identify personnel/positions with required logs; track submitted/outstanding; reminders; review; archive while preserving content permissions.',
      'FOC-PLN-004d — Record Version and Supersession: published/submitted records preserved; revisions create traceable versions with user, date/time, reason/status, and clear current/superseded indication.',
      'FOC-PLN-004e — Incident Archive Readiness: before closure, identify missing required records, unresolved drafts, outstanding signatures/approvals, incomplete activity logs, and other archive deficiencies without changing operational records.',
    ],
  }),
  requirement({
    id: 'al006',
    requirementId: 'US-AL006',
    name: 'Export ICS 214',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pln-docs-workspace',
    description:
      'Generate and export the ICS-214 (Activity Log) document based on recorded entries so compliant official documentation can be submitted for the incident record.',
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_PLN_DOCS),
  },
];
